// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__2NgHR","SubTitle":"style_SubTitle__2VGtC"};